import React, { useMemo } from 'react';
import { SigningAppointmentDescriptionTooltip } from '../../../../signingAppointments/SigningAppointmentDescriptionTooltip';
import { Show } from '../../../../../shared/Show';
import { eSigningMethod } from '../../../../../../types/signingAppointment/eSigningMethod';
import { languageOptions } from '../../../commonOptions';
import { ToggleTW } from '../../../../../../tailwindComponents/toggleTW/ToggleTW';
import { SelectFieldTW } from 'tailwindComponents/selectTW/SelectFieldTW';
import { useGetSigningInfoOptions } from './hooks/useGetSigningInfoOptions';
import { useFormikContext } from 'formik';
import { IDetailsFormData } from './types/IDetailsFormData';

/* Select the method of the SigningAppointment (notary, e-sign, etc.)
 */
export const SigningInfoSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IDetailsFormData>();
  const { signingMethodOptions, signingTypeOptions, methodDescriptions } = useGetSigningInfoOptions();

  const formatOptionLabel = useMemo(
    () => (option: any) => (
      <SigningAppointmentDescriptionTooltip type={'status'} option={option} optionDescriptions={methodDescriptions} />
    ),
    [methodDescriptions]
  );

  return (
    <section className={'mb-4 mt-3'}>
      <div className={'mb-3 text-base font-semibold leading-6'}>Signing Info</div>

      <div className={'mb-3 flex gap-4 whitespace-nowrap'}>
        <SelectFieldTW
          className={'w-4/12'}
          name={'signingMethod'}
          options={signingMethodOptions}
          labelText="Signing Method"
          placeholder={`Select a method`}
          isRequired
          onChange={(value) => {
            setFieldValue('address', undefined);
            if (value.value !== eSigningMethod.notaryOnly) {
              setFieldValue('isSignatureSyncAppointment', undefined, true);
            }
          }}
          formatOptionLabel={formatOptionLabel}
        />
        <SelectFieldTW
          className={'w-5/12'}
          name={'signingType'}
          options={signingTypeOptions}
          labelText="Signing Type"
          placeholder={`Select a category`}
        />
        <div className={'w-3/12'}>
          <Show when={shouldShowLanguageField(values.signingMethod)}>
            <SelectFieldTW
              isCreatable
              name="language"
              labelText="Preferred Language"
              placeholder={`Select a language`}
              options={languageOptions}
            />
          </Show>
        </div>
      </div>
      <Show when={values.signingMethod === eSigningMethod.notaryOnly}>
        <ToggleTW
          onChange={(value) => {
            if (value) {
              setFieldValue('isDateRange', false);
              setFieldValue('availableStartDate', undefined);
              setFieldValue('availableEndDate', undefined);
            }
          }}
          name="isSignatureSyncAppointment"
          text="Signature Sync"
          data-test-id={'is-sigsync'}
          className="mb-3"
        />
      </Show>
    </section>
  );
};

const shouldShowLanguageField = (signingMethod?: string) =>
  signingMethod !== eSigningMethod.thirdPartyNotary && signingMethod !== eSigningMethod.wetSign;
